import { useDispatch, useSelector } from 'react-redux';

import {
  Modal,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Heading,
  ModalFooter,
  ModalButtonGroup,
} from '@frontend/legacy-components';

import { invitesSentModal } from './data/actions';
import { getIsInvitesSentModalOpen } from './data/selectors';

export const InvitesSentModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getIsInvitesSentModalOpen);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => dispatch(invitesSentModal.close())}
      size="md"
    >
      <ModalContent>
        <ModalCloseButton />
        <ModalBody px={4} pt={6}>
          <VStack spacing={1} align="center">
            <img
              width="88px"
              height="77px"
              src="https://s3.amazonaws.com/static.paperlessparts.com/images/invite-icon.png"
              alt="invite icon"
            />
            <Heading>Invites Sent</Heading>
            <Text textAlign="center" size="lg">
              You can always send more invites from the Team page.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter justifyContent="center" border="none" pb={4}>
          <ModalButtonGroup>
            <Button
              variant="secondary"
              onClick={() => dispatch(invitesSentModal.close())}
            >
              Close
            </Button>
          </ModalButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
